import React, { useEffect, useState } from "react";

const BaseModalAnimated = ({
  modal,
  setModal,
  children,
  onCloseModal,
  title, // opcional: si no, usa modal.title
  size
}) => {
  const [visible, setVisible] = useState(false); // render
  const [showModal, setShowModal] = useState(false); // animación

  // Sync con modal.show
  useEffect(() => {
    if (modal.show) {
      setVisible(true);
      requestAnimationFrame(() => setShowModal(true));
    } else if (visible) {
      setShowModal(false);
      const timer = setTimeout(() => setVisible(false), 260);
      return () => clearTimeout(timer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modal.show]);

  const closeModal = () => {
    if (onCloseModal) return onCloseModal();

    setShowModal(false);

    setTimeout(() => {
      setVisible(false);
      setModal((prev) => ({
        ...prev,
        show: false,
        id: null,
      }));
    }, 260);
  };

  if (!visible) return null;

  const headerTitle = title || modal.title || "";

  return (
    <>
      {/* Overlay con blur y fade */}
      <div
        className={`
          fixed inset-0 z-40
          bg-black/40 backdrop-blur-sm
          transition-opacity duration-300
          ${showModal ? "opacity-100" : "opacity-0"}
        `}
        onClick={closeModal}
      />

      {/* Contenedor modal */}
      <div
        className={`
          fixed inset-0 z-50
          flex items-start justify-center
          px-3 py-4 sm:px-4 sm:py-6
          overflow-x-hidden overflow-y-auto
          outline-none
        `}
      >
        <div
          className={`
            relative my-auto w-full ${size || 'max-w-2xl'}
            max-h-[calc(100vh-2rem)] sm:max-h-[calc(100vh-3rem)]
            transform transition-all duration-300 ease-out
            ${showModal
              ? "opacity-100 translate-y-0 scale-100"
              : "opacity-0 translate-y-4 scale-95"}
          `}
        >
          <div
            className="
              relative flex max-h-[inherit] flex-col
              bg-cs-bg
              border border-cs-border/70
              rounded-2xl
              shadow-[0_18px_70px_rgba(15,23,42,0.25)]
              outline-none
              overflow-hidden
            "
          >
            {/* Línea/acento superior */}
            <div className="h-1 bg-gradient-to-r from-cs-primary via-cs-primary-soft to-transparent" />

            {/* Header */}
            <div
              className="
                sticky top-0 z-10
                flex items-center justify-between gap-3
                px-4 py-3
                border-b border-cs-border/60
                bg-cs-bg/95 backdrop-blur-sm
                shrink-0
              "
            >
              <h3 className="text-sm font-semibold text-cs-dark truncate">
                {headerTitle}
              </h3>

              <button
                type="button"
                onClick={closeModal}
                className="
                  inline-flex items-center justify-center
                  w-7 h-7
                  rounded-full
                  border border-cs-border/70
                  text-cs-muted
                  hover:bg-cs-primary-soft
                  hover:text-cs-primary-dark
                  transition-all
                "
              >
                <span className="material-symbols-outlined text-[18px]">
                  close
                </span>
              </button>
            </div>

            {/* Body */}
            <div className="flex-1 overflow-y-auto p-3 sm:p-4">
              {children}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BaseModalAnimated;
